import { createSlice } from "@reduxjs/toolkit";
import { AppStorageKeys } from "../Constants/Constants";
import LocalStorage from "../Constants/LocalStorage";
import SessionStorage from "../Constants/SessionStorage";
import {
  getCurrentUserFromStorage,
  getUserRoleConfigFromStorage,
} from "../Constants/Utilities";
import { getUserFeatureList } from "../Components/AccessControl/General";

const initialState = {};
const currentUser = getCurrentUserFromStorage();
!!currentUser && (initialState.currentUser = currentUser);
const userRoleConfig = getUserRoleConfigFromStorage();
!!userRoleConfig && (initialState.userRoleConfig = userRoleConfig);

const authStore = createSlice({
  name: "authentication",
  initialState,
  reducers: {
    loginSuccess: (state, action) => {
      const { userInfo, remember } = action.payload;
      const {
        username,
        partner,
        providerId,
        providerType,
        access_token,
        roles,
      } = userInfo;
      const currentUser = {
        username,
        partner,
        providerId,
        providerType,
        access_token,
        roles,
      };
      const userFeatures = getUserFeatureList(roles, state.userRoleConfig);
      currentUser.userFeatures = userFeatures;
      state.currentUser = currentUser;
      if (remember) {
        LocalStorage.set(AppStorageKeys.currentUser, currentUser);
      } else {
        SessionStorage.set(AppStorageKeys.currentUser, currentUser);
      }
    },
    loginFailure: (state) => {
      state.currentUser = null;
      LocalStorage.remove(AppStorageKeys.currentUser);
      SessionStorage.remove(AppStorageKeys.currentUser);
    },
    updateCurrentUser: (state, action) => {
      const { key, value } = action.payload;
      state.currentUser[key] = value;
    },
    logout: (state) => {
      state.currentUser = null;
      LocalStorage.remove(AppStorageKeys.currentUser);
      SessionStorage.remove(AppStorageKeys.currentUser);
    },
  },
});

export const { loginSuccess, loginFailure, logout, updateCurrentUser } =
  authStore.actions;

export default authStore.reducer;
